module.exports = __webpack_public_path__ + "static/media/art47.98057b3f.jpg";